import type { QueryClient } from '@tanstack/react-query';

import type { Persona } from '../../../domain/persona';
import type { AppStore } from '../../../services/appStore';
import { translate } from '../../../services/i18n';
import { personaApi } from '../api';
import { PERSONAS_QUERY_KEY } from '../personasQuery/personasQueryKey';

import type { DeletePersonaRepository } from './useCase';

export const makeDeletePersonaRepository = (appStore: AppStore, queryClient: QueryClient): DeletePersonaRepository => ({
  deletePersona: (persona: Persona) => personaApi.deletePersona(persona),
  removePersona: (persona: Persona) => {
    queryClient.setQueryData<Persona[]>(
      PERSONAS_QUERY_KEY,
      (personas) => personas?.filter((p) => p.id !== persona.id) ?? []
    );

    if (appStore.getState().contactFilters.persona?.id === persona.id) {
      appStore.setContactsPersona(undefined);
    }
  },
  notifyPersonaDeleted: (persona: Persona) => {
    appStore.setToast({
      content: translate('contacts.persona.deleted', { personaName: persona.name }),
    });
  },
});
